// Import SASS
import '../sass/style.scss'

// import scripts
import './modules/navigation';
import './modules/flexslider';
import './modules/accordion';
import './modules/animate-it';
import './modules/typed';
import './modules/scrollUp';
import './modules/sticky-kit';
import './modules/picturefill';
import objectFitImages from 'object-fit-images'
// import { getProducts, getResults } from './modules/search'; // Old search
import map from './modules/map';

import search from '../template-parts/partials/search-bar/search-bar'

search('.header-search-bar');

map('map')

// Object-fit fix
objectFitImages()

// Search products OLD
// getProducts();
// const searchInput = document.querySelector('.search-field');
// const searchResults = document.querySelector('.search-form__results');
// searchInput.addEventListener('keyup', (e) => {
//     const value = e.target.value;
//     getResults(value);
//     searchResults.style.display = 'flex';
//     if (value.length === 0) {
//         searchResults.style.display = 'none';
//     }
// });

$("#typed").typed({
    stringsElement: $('#typed-strings'),
    typeSpeed: 25,
    startDelay: 1000
});

$('.cloud .cloud--title').each(function() {
    var text = $(this).text();
    $(this).text(text.replace('Spraakherkenning voor', ' ')); 
});


$.scrollUp({
    scrollText: '<svg class="middle" height="25" width="25"><use xlink:href="#pijl-omhoog"></use></svg>',
    scrollDistance: 500
});

/* Accordion bij meestgestelde vragen */
$('.accordion').accordion({
    "transitionSpeed": 400
});	
	
/* Search zichtbaar maken */
$(".search-icon").click(function() {  
    $('.header--search').toggleClass("open");      
    $('.search-field').focus();      
});

/* Mobiele shop-filters zichtbaar maken */
$(function() {                      
	$(".shop--sidebar > div").click(function() {  
		$('.shop--sidebar').toggleClass("open");  
		});
});	

/* Floating sidebar op shop page */
if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
    $(".shop--sidebar aside").stick_in_parent({offset_top: 110});		
};
$('#aanhef_field').insertBefore('#billing_first_name_field');

/* Testimonials slider */
var $window = $(window),
    flexslider = { vars:{} };

// tiny helper function to add breakpoints
function getGridSize() {
return (window.innerWidth < 600) ? 1 : (window.innerWidth < 900) ? 2 : 2; }
$window.load(function() {
    $('.testimonials--slider').flexslider({
        animation: "slide",
        directionNav: false,
        animationLoop: false,
        itemWidth: 210,
        slideshowSpeed: 13000,
        itemMargin: 5,
        minItems: getGridSize(), // use function to pull in initial value
        maxItems: getGridSize() // use function to pull in initial value
    });
});

// check grid size on resize event
$window.resize(function() {
var gridSize = getGridSize();

flexslider.vars.minItems = gridSize;
flexslider.vars.maxItems = gridSize;
});

